"use client";

import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { Span } from "@faire/web--source/slate/Typography";
import { ISlateTextElement } from "@faire/web-api--source/indigofair/data/ISlateTextElement";
import React from "react";
import styled, { css } from "styled-components";

interface IProps {
  textElement: ISlateTextElement | undefined;
  isUnderlined?: boolean;
}

export const SlateText: React.FC<IProps> = ({ textElement, isUnderlined }) => {
  if (!textElement?.text) {
    return null;
  }

  const variant = getSlateTypographyVariant(
    textElement?.style?.type,
    textElement?.style?.decorators
  );

  const color = getSlateColorToken(textElement?.style?.color);

  return (
    <StyledSpan variant={variant} color={color} $isUnderlined={isUnderlined}>
      {textElement.text}
    </StyledSpan>
  );
};

const StyledSpan = styled(Span)<{ $isUnderlined?: boolean }>`
  text-decoration: ${({ $isUnderlined, color }) =>
    $isUnderlined ? css`underline ${color}` : "none"};
`;
